export default __webpack_public_path__ + "static/media/labeldat_logo.fbd2359e.png";